import { ReactNode } from "react";

export class DashboardModel {
  title: string;
  value: number | string;
  icon: ReactNode;
  description?: string;
  metaData?: string[];
  iconClass?: string;

  constructor(
    title: string,
    value: number | string,
    icon: ReactNode,
    description?: string,
    metaData?: string[],
    iconClass?: string
  ) {
    this.title = title;
    this.value = value;
    this.icon = icon;
    this.description = description;
    this.metaData = metaData;
    this.iconClass = iconClass;
  }
}
